import { useQuery } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import { execute, gql } from '~/services-v2/financial-bff/financial-bff-gql'

const query = gql(`
  query InvertersBrands {
    inverter_brands {
      brands
    }
  }
`)

export default function useInvertersBrands() {
  const queryKey = queryKeys.INSTALLATION.INVERTERS_BRANDS

  const queryFn = async () => {
    const res = await execute(query, {})

    return res.inverter_brands.brands
  }

  return useQuery({
    queryKey,
    queryFn,
  })
}
